import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { useInternationalization } from '@progress/kendo-react-intl';
import { isUndefined } from 'lodash';
import { useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import useDelayedInputOnchange from 'src/hooks/useDelayedInputOnchange';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import { getBgColor } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';

const InvoiceAmountCell = (props: GridCellProps) => {
  const distributionType = useContextSelector(InvoiceContext, (value) => value.distributionType);
  const hasDistributionPermission = useContextSelector(
    InvoiceContext,
    (value) => value.hasDistributionPermission
  );
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);

  const { field = '', dataItem } = props;
  const intl = useInternationalization();

  const value1 = dataItem[field]?.toString();
  const formatted =
    Number(value1) < 0
      ? '-$' + intl.format('{0:n2}', Math.abs(Number(value1)) || 0)
      : '$' + intl.format('{0:n2}', Number(value1) || 0);

  const error: string[] = useMemo(() => dataItem?.errors?.amount, [dataItem?.errors?.amount]);
  const { value, handleChange } = useDelayedInputOnchange(props);

  const handle = useCallback(
    (e: TextBoxChangeEvent) => {
      e.value =
        typeof e.value === 'string' && e.value.trim() === ''
          ? ''
          : Number(invoice?.totalCostAmt) < 0
          ? Math.abs(Number(e.value)) * -1
          : Math.abs(Number(e.value));
      handleChange(e);
    },
    [handleChange, invoice?.totalCostAmt]
  );

  if (!hasDistributionPermission || distributionType !== 'Amount') {
    return (
      <GridCellBase {...props} title={formatted}>
        <p className="text-right">{formatted}</p>
      </GridCellBase>
    );
  }

  return (
    <GridCellBase {...props} title={formatted} className={getBgColor(error)}>
      <NumberInput
        value={isUndefined(value) ? '' : value}
        onChange={handle}
        prefix="$"
        valid={!error?.length}
      />
    </GridCellBase>
  );
};

export default InvoiceAmountCell;
